import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  firstButton: {
    marginRight: 8, // Gap between the buttons
  },
  text: {
    lineHeight: 32,
  },
  buttonContainer: {
    flexDirection: 'row',
    width: '100%',
  },
});
